import React from 'react';

const Profession: React.FC = () => {
  return (
    <div>
      <h1>Profession</h1>
      <p>This is the Profession component.</p>
    </div>
  );
};

export default Profession;
